import React from 'react';
import { usePermissions } from '../permissions/PermissionContext';
import { AlertMessage } from './ui/AlertMessage';

function AccessRestricted() {
  const { accessMessage, roleName } = usePermissions();

  return (
    <div className="mx-auto flex max-w-2xl flex-col gap-4 py-8">
      <AlertMessage
        type="warning"
        message={
          accessMessage ||
          'Your account does not have an application role assigned. Please contact your administrator to get access to modules.'
        }
      />
      <div className="rounded-2xl border border-slate-200/80 bg-white p-6 shadow-sm">
        <h2 className="text-lg font-semibold text-slate-900">What you can do</h2>
        <p className="mt-2 text-sm text-slate-600 leading-relaxed">
          Until an administrator assigns you a role (for example Manager, Operator, or another
          role), you can only update your profile and sign out. Use the profile menu in the top
          right corner to open <strong className="font-medium text-slate-800">My Profile</strong>.
        </p>
        {roleName && (
          <p className="mt-3 text-sm text-slate-500">
            Current role label: <span className="font-medium text-slate-700">{roleName}</span>
          </p>
        )}
      </div>
    </div>
  );
}

export default AccessRestricted;
